import { decodeStoredHtml } from './storedHtml.js';
/**
 * A block with inline on* handlers self-injects (the find-my-shade quiz renders
 * its copy twice when SSR'd), so the storefront renders those client-side.
 * Matched inside a tag at a word boundary, so every attribute form is caught —
 * spaced, quoted, or glued like <img/onerror=> — while an on*= in prose is not.
 */
export const hasInlineHandlers = (html) => /<[a-z][^>]*\bon[a-z]+\s*=/i.test(html);
/**
 * Whether an HTML section can be edited directly in the preview.
 *
 * Sections that wire up their own JavaScript are excluded: the click that
 * places a caret also fires the widget's handlers, and the DOM the widget
 * rewrites for itself would then be serialized back as though the merchant had
 * typed it. Those sections stay on the source editor.
 */
export const isHtmlSectionLiveEditable = (storedHtml) => !hasInlineHandlers(decodeStoredHtml(storedHtml).decoded);
/**
 * Stamped by the backend on the root elements of HTML the model authored
 * against the container-aware contract, so the scrolling layout can widen
 * those sections to the page while markup written for the old 470px column
 * keeps its width [sc-36409].
 */
export const HTML_DESKTOP_READY_ATTR = 'data-desktop-ready';
const DESKTOP_READY_TAG = new RegExp(`<[a-z][^>]*\\b${HTML_DESKTOP_READY_ATTR}\\b`, 'i');
export const isHtmlSectionDesktopReady = (storedHtml) => DESKTOP_READY_TAG.test(decodeStoredHtml(storedHtml).decoded);
